
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ThemeConstantService } from './services/theme-constant.service';
import { SearchPipe } from './pipes/search.pipe';
import {ItemCountComponent} from './components/item-count/item-count.component';
import {HasAnyAuthorityDirective} from './directives';
import {CookieModule} from 'ngx-cookie';
import {IconFilterPipe} from './pipes/iconFilter.pipe';
import { SearchFilterComponent } from 'src/app/shared/components/search-filter/search-filter.component';
import { ErrorTextComponent } from 'src/app/shared/components/error-text/error-text.component';
import { ConfirmPopUpComponent } from 'src/app/shared/components/confirm-popup/confirm-popup.component';
import { TransformCustomDatePipe } from 'src/app/shared/pipes/transformCustomDate.pipe';
import { TransformMoneyPipe } from './pipes/transformMoney.pipe';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule  } from 'ng-zorro-antd/select';
import { NzSliderModule  } from 'ng-zorro-antd/slider';
import { NzTableModule  } from 'ng-zorro-antd/table';
import { NzTabsModule  } from 'ng-zorro-antd/tabs';
import { NzAvatarModule  } from 'ng-zorro-antd/avatar';
import { NzAlertModule  } from 'ng-zorro-antd/alert';
import { NzProgressModule  } from 'ng-zorro-antd/progress';
import { NzToolTipModule   } from 'ng-zorro-antd/tooltip';
import { NzPopoverModule    } from 'ng-zorro-antd/popover';
import { NzSwitchModule   } from 'ng-zorro-antd/switch';
import { InputNumberComponent } from './components/input-number/input-number';
import { InputDateComponent } from './components/input-date/input-date';
import { InputDatePickerAndTimeComponent } from './components/input-datepicker-and-time/input-datepicker-and-time';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { FilterStartEndDateComponent } from './components/filter-start-end-date/filter-start-end-date';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { DropdownSearchModule } from './components/dropdown-search/dropdown-search.module';

@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        NzIconModule,
        NzTagModule,
        NzBadgeModule,
        NzModalModule,
        NzCardModule,
        NzTabsModule,
        NzListModule,
        NzPageHeaderModule,
        NzFormModule,
        NzLayoutModule,
        NzDropDownModule,
        NzButtonModule,
        NzSelectModule,
        NzSliderModule,
        NzSpinModule,
        NzTableModule,
        NzAvatarModule,
        NzInputModule,
        NzAlertModule,
        NzPaginationModule,
        NzProgressModule,
        NzToolTipModule,
        NzPopoverModule,
        NzSwitchModule,
        NzDividerModule,
        NzMenuModule,
        IconFilterPipe,
        SearchPipe,
        HasAnyAuthorityDirective,
        SearchFilterComponent,
        ErrorTextComponent,
        TransformCustomDatePipe,
        TransformMoneyPipe,
        InputNumberComponent,
        InputDateComponent,
        DropdownSearchModule,
        InputDatePickerAndTimeComponent,
        FilterStartEndDateComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NzTagModule,
        NzDropDownModule,
        NzBadgeModule,
        NzModalModule,
        NzIconModule,
        NzTagModule,
        NzBadgeModule,
        NzModalModule,
        NzCardModule,
        NzTabsModule,
        NzListModule,
        NzPageHeaderModule,
        NzFormModule,
        NzLayoutModule,
        NzDropDownModule,
        NzButtonModule,
        NzSelectModule,
        NzSliderModule,
        NzSpinModule,
        NzTableModule,
        NzAvatarModule,
        NzInputModule,
        NzAlertModule,
        NzPaginationModule,
        NzProgressModule,
        NzToolTipModule,
        NzPopoverModule,
        NzSwitchModule,
        NzDividerModule,
        NzMenuModule,
        DropdownSearchModule,
        CookieModule.forRoot()
    ],
    declarations: [
        IconFilterPipe,
        SearchPipe,
        ItemCountComponent,
        ErrorTextComponent,
        HasAnyAuthorityDirective,
        SearchFilterComponent,
        ConfirmPopUpComponent,
        TransformCustomDatePipe,
        TransformMoneyPipe,
        InputNumberComponent,
        InputDateComponent,
        InputDatePickerAndTimeComponent,
        FilterStartEndDateComponent
    ],
    providers: [
        ThemeConstantService
    ]
})

export class SharedModule { }
